import type { RouteProps } from '@truepill/tpos-react-router'
import { Route } from '@truepill/tpos-react-router'
import type { UserRoles } from '@truepill/tpos-types'
import AccessDenied from 'components/AccessDenied'
import { usePlusClient } from 'providers/VisionRouter'

type AuthenticatedRouteProps = RouteProps & { roles?: UserRoles[] }

const AuthenticatedRoute = ({ roles, ...rest }: AuthenticatedRouteProps): JSX.Element => {
  const {
    tokenContext: { hasRole },
  } = usePlusClient()

  if (roles && !hasRole(roles)) {
    return (
      <Route
        {...rest}
        render={() => <AccessDenied />}
        component={undefined}
        // eslint-disable-next-line react/no-children-prop
        children={undefined}
      />
    )
  }

  return <Route {...rest} />
}
export default AuthenticatedRoute
